// import { Button } from "@mui/material";

// export const defaultValue = 1;
// export const myCars = 0;
// export const othersCars = 1;

// const MyCarsOrOtherCarsButton = ({
//   value,
//   setValue
// }) => {
//   return (
//     <Button
//       onClick={() => {
//         if (setValue) {
//           setValue(value => {
//             if (value === 0) {
//               return 1;
//             } else {
//               return 0;
//             }
//           })
//         }
//       }}
//     >
//       {value === 0 ? (
//         "Other Cars"
//       ) : (
//         "My Cars"
//       )}
//     </Button>
//   )
// };

// export default MyCarsOrOtherCarsButton;

import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const defaultValue = 1;

const MyCarsOrOtherCarsButton = ({ value, setValue, fullWidth = false }) => {
  const { t } = useTranslation('upcomingCars');

  return (
    <Button
      fullWidth={fullWidth}
      sx={{ fontSize: `${20 / 16}rem`, fontWeight: 500, width: `${150 / 16}rem` }}
      onClick={() => {
        if (setValue) {
          setValue((prevValue) => (prevValue === 0 ? 1 : 0));
        }
      }}
    >
      {value === 0 ? t('othersCars') : t('myCars')}
    </Button>
  );
};

export default MyCarsOrOtherCarsButton;
